"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setting = void 0;
class Setting {
    type;
}
exports.Setting = Setting;
//# sourceMappingURL=Setting.js.map